<nav class="navbar">
  <div class="navbar-container">
    <!-- Logo Section -->
    <div class="navbar-brand">
      <img ngSrc="assets/logo.png" alt="HRM 2.0 Logo" class="logo-image" width="119" height="40"/>
      <div class="brand-text">
        <span class="brand-title">HRM</span>
        <span class="brand-subtitle">Health & Risk Management</span>
      </div>
    </div>

    <!-- Navigation Items -->
    <ul class="nav-items">
      @for (item of visibleNavItems(); track item.route) {
        <li class="nav-item">
          @if (item.children) {
            <button
              class="nav-link dropdown-trigger"
              [class.active]="isAdminRoute()"
              [matMenuTriggerFor]="adminDropdown"
              [attr.data-icon]="item.icon"
            >
              <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
              <span class="nav-label">{{ item.label }}</span>
              <mat-icon class="dropdown-arrow">arrow_drop_down</mat-icon>
            </button>
            <mat-menu #adminDropdown="matMenu">
              @for (child of item.children; track child.route) {
                <a mat-menu-item [routerLink]="child.route" [attr.data-icon]="child.icon">
                  <mat-icon>{{ child.icon }}</mat-icon>
                  <span>{{ child.label }}</span>
                </a>
              }
            </mat-menu>
          } @else {
            <a 
              [routerLink]="item.route" 
              routerLinkActive="active"
              class="nav-link"
              [attr.data-icon]="item.icon"
            >
              <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
              <span class="nav-label">{{ item.label }}</span>
            </a>
          }
        </li>
      }
      
      <!-- Theme Toggle Button -->
      <li class="nav-item theme-toggle-item">
        <button 
          class="theme-toggle-button"
          (click)="toggleTheme()"
          aria-label="Toggle theme"
        >
          <mat-icon class="theme-icon"> {{ theme.theme() === 'light' ? 'light_mode' : 'dark_mode' }}</mat-icon>
        </button>
      </li>

      <!-- User Menu -->
      <li class="nav-item user-menu-item">
        <button 
          mat-button
          [matMenuTriggerFor]="userMenu"
          class="user-menu-button"
        >
          <span class="user-avatar" aria-hidden="true">{{ userInitials() }}</span>
          <span class="user-name">{{ userName() }}</span>
        </button>
      </li>
    </ul>

    <!-- Mobile Menu Button -->
    <button 
      mat-icon-button 
      class="mobile-menu-button"
      [matMenuTriggerFor]="mobileMenu"
      aria-label="Open navigation menu"
    >
      <mat-icon>menu</mat-icon>
    </button>
  </div>
</nav>

<!-- User Menu -->
<mat-menu #userMenu="matMenu">
  <button mat-menu-item disabled class="user-menu-profile">
    <span class="user-avatar user-avatar--menu" aria-hidden="true">{{ userInitials() }}</span>
    <span>{{ userName() }}</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="signOut()">
    <mat-icon>logout</mat-icon>
    <span>Sign Out</span>
  </button>
</mat-menu>

<!-- Mobile Menu -->
<mat-menu #mobileMenu="matMenu" class="mobile-nav-menu">
  @for (item of visibleNavItems(); track item.route) {
    @if (item.children) {
      @for (child of item.children; track child.route) {
        <a 
          mat-menu-item 
          [routerLink]="child.route"
          routerLinkActive="active"
          class="mobile-nav-item"
        >
          <mat-icon>{{ child.icon }}</mat-icon>
          <span>{{ child.label }}</span>
        </a>
      }
    } @else {
      <a 
        mat-menu-item 
        [routerLink]="item.route"
        routerLinkActive="active"
        class="mobile-nav-item"
        [attr.data-icon]="item.icon"
      >
        <mat-icon>{{ item.icon }}</mat-icon>
        <span>{{ item.label }}</span>
      </a>
    }
  }
  <button 
    mat-menu-item 
    class="mobile-nav-item theme-toggle-mobile"
    (click)="toggleTheme()"
  >
    <span>Toggle Theme</span>
    <mat-icon>light_mode</mat-icon>
  </button>
  <button mat-menu-item (click)="signOut()">
    <mat-icon>logout</mat-icon>
    <span>Sign Out</span>
  </button>
</mat-menu>
